import { useApiClient } from '~/api-client';
import { useEnabledFeatures } from '../../common/hooks/enabled-features/use-enabled-features';
import { DispositionResource } from '@mark43/cad-api';
import { useQuery } from '@tanstack/react-query';

export function useDispositionQuery({
    agencyEventId,
    enabled,
}: {
    agencyEventId?: number;
    /* Defaults to fetching only when unit-level dispositions are enabled. With unit-level
     * dispositions off there is no disposition to fetch until the event is cleared (dispositions
     * are stored on the event-clearing record), so the clear-event flow starts from a blank form.
     * The edit-disposition flows pass `enabled: true` so they still fetch (and pre-fill) the
     * existing disposition from that event-clearing record even when unit-level dispositions are
     * off. */
    enabled?: boolean;
}) {
    const { unitLevelDispositionsEnabled } = useEnabledFeatures();
    const apiClient = useApiClient();

    const query = useQuery({
        queryKey: ['disposition', agencyEventId],
        queryFn() {
            if (agencyEventId) {
                return apiClient
                    .request<DispositionResource.BootstrapDispositionsModal>({
                        method: 'POST',
                        url: 'disposition/bootstrap',
                        data: { agencyEventId },
                    })
                    .then((res) => {
                        return res.data.data;
                    });
            }
        },
        enabled: enabled ?? unitLevelDispositionsEnabled,
    });

    return query;
}
